import createStyles from '@material-ui/core/styles/createStyles'
import makeStyles from '@material-ui/core/styles/makeStyles'

const styles = () => createStyles({
  targetMode: {
    textTransform: 'uppercase',
    fontWeight: 800,
  },
})

export default makeStyles(styles)
